import { Capacitor } from '@capacitor/core';
import { InAppBrowser, OpenWebViewOptions } from '@capgo/inappbrowser';
import { captureException } from '@sentry/react';

export function useInAppBrowser() {
  const defaultOpenWebViewOptions: OpenWebViewOptions = {
    url: '',
    title: '',
    showReloadButton: true,
    // Android WebView disables Payment Request API by default; iOS flag injects an unwanted user script.
    enableGooglePaySupport: Capacitor.getPlatform() === 'android',
  };

  return {
    close: InAppBrowser.close,
    open: async (
      options: Partial<OpenWebViewOptions>,
      e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
      e?.preventDefault();
      InAppBrowser.openWebView({
        ...defaultOpenWebViewOptions,
        ...options,
      }).catch((error) => {
        console.error(error);
        captureException(error);
      });
    },
    setUrl: async (url: string) => {
      InAppBrowser.setUrl({ url }).catch((error) => {
        console.error(error);
        captureException(error);
      });
    },
  };
}
